import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {
  LoadUnit,
  LoadUnitCreate,
  GetParams,
  GetResponse,
  PostResponse,
  PackageType,
  LoadUnitTemplate, LoadUnitTemplateCreate
} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class LoadUnitService {
  /** URLs principales relacionadas con LoadUnit **/
  loadUnitUrl = environment.coreApiBaseUrl + '/api/load-unit';
  loadUnitTemplateUrl = environment.coreApiBaseUrl + '/api/load-unit-template';
  packageTypeUrl = environment.coreApiBaseUrl + '/api/PackageType';
  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar LoadUnit **/
  getLoadUnit(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.loadUnitUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createLoadUnit(newLoadUnit: LoadUnitCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.loadUnitUrl, newLoadUnit);
  }

  updateLoadUnit(loadUnit: LoadUnit): Observable<any> {
    return this.http.put(this.loadUnitUrl, loadUnit);
  }

  deleteLoadUnit(loadUnitsIds: number[]): Observable<any> {
    return this.http.delete(this.loadUnitUrl, {body: {ids: loadUnitsIds}});
  }

  patchLoadUnit(value: any): Observable<any> {
    return this.http.patch(this.loadUnitUrl, value);
  }

  getPackageType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.packageTypeUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createPackageType(newPackageType: {name: string, code: string}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.packageTypeUrl, newPackageType);
  }

  updatePackageType(PackageType: PackageType): Observable<any> {
    return this.http.put(this.packageTypeUrl, PackageType);
  }

  deletePackageType(PackageTypesIds: number[]): Observable<any> {
    return this.http.delete(this.packageTypeUrl, {body: {ids: PackageTypesIds}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar LoadUnitTemplate **/
  getLoadUnitTemplate(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.loadUnitTemplateUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createLoadUnitTemplate(newLoadUnitTemplate: LoadUnitTemplateCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.loadUnitTemplateUrl, newLoadUnitTemplate);
  }

  updateLoadUnitTemplate(LoadUnitTemplate: LoadUnitTemplate): Observable<any> {
    return this.http.put(this.loadUnitTemplateUrl, LoadUnitTemplate);
  }

  patchLoadUnitTemplate(value: any): Observable<any> {
    return this.http.patch(this.loadUnitTemplateUrl, value);
  }

  deleteLoadUnitTemplate(LoadUnitTemplatesIds: number[]): Observable<any> {
    return this.http.delete(this.loadUnitTemplateUrl, {body: {ids: LoadUnitTemplatesIds}});
  }
}
